import { baseService } from '@repo/services';

export interface AhoyMessageContentProps {
  content: string;
  subject: string;
  from: string[];
  to: string[];
  cc: string[];
  bcc: string[];
  date: string;
  attachments: {
    filename: string;
    url: string;
  }[];
}

export const ahoyMessageService = baseService.injectEndpoints({
  endpoints: (build) => ({
    getAhoyMessageContent: build.query<AhoyMessageContentProps, number | string>({
      query: (id) => ({
        url: `v1/ahoy/message/${id}/mail_content`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetAhoyMessageContentQuery,
} = ahoyMessageService;

export default ahoyMessageService;
